import { Span } from "../../interfaces/components/mainTable";

export const computeRowSpans = (
  data: any[],
  columns: string[],
): Array<Span[]> => {
  const spans: Array<Span[]> = columns.map(() => []);
  const spanColumnContexts: any[] = new Array(columns.length);

  for (const row of data) {
    for (let iCol = 0; iCol < columns.length; iCol++) {
      const column = columns[iCol];
      const spanColumnContext = spanColumnContexts[iCol];

      if (
        spanColumnContext &&
        spanColumnContext.spannedRow[column] === row[column]
      ) {
        ++spanColumnContext.span.span;
        spans[iCol].push({ span: 0 });
      } else {
        const span = { span: 1 };
        spanColumnContexts[iCol] = { span: span, spannedRow: row };
        spans[iCol].push(span);
        spanColumnContexts.slice(iCol + 1).forEach((c) => (c.spannedRow = {}));
      }
    }
  }
  return spans;
};
